import angular from 'angular';
import generator from 'generate-password-browser';
import template from './password.html';
import APIV5 from '~/models/api';
import './password.scss';

const passwordConfig = /* @ngInject */ (/** @type {any} */ KformComponentsProvider) => {
	KformComponentsProvider.register('password', {
		title:      'Password',
		template,
		children:   false,
		selectable: true,
		settings:   {
			autofocus:    false,
			disabled:     false,
			input:        true,
			tableView:    true,
			inputType:    'password',
			label:        'Password',
			key:          'password',
			hideLabel:    false,
			placeholder:  '',
			prefix:       '',
			suffix:       '',
			defaultValue: '',
			protected:    false,
			persistent:   true,
			hidden:       false,
			clearOnHide:  true,
			allowToggle:  true,
			showPass:     false,
			validate:     {
				card:     '0-1',
				minLength: null,
				maxLength: null,
				integer:  '',
				custom:   '',
			},
			event:        {
				onChange: null,
			},
			kdata: {
				submit: true,
			},
			process: {
				disabled: null,
				hidden: null,
				list: [],
			},
			rule: {
				disabled: null,
				hidden: null,
				order: 'K_NODE;NCRULE',
				value: undefined,
			}
		},
		icon: 'fa fa-asterisk',
		views:      [
			{
				name:     'Display',
				template: 'kform/components/password/display.html',
			},
			{
				name:     'Validation',
				template: 'kform/components/textfield/validate.html',
			},
			{
				name:     'API',
				template: 'kform/components/common/api.html',
			},
			{
				name:     'Layout',
				template: 'kform/components/common/layout.html',
			},
			{
				name:     'Conditional',
				template: 'kform/components/common/conditional.html',
			},
			{
				name:     'Events',
				template: 'kform/components/common/events.html',
			},
		],
		controller: /* @ngInject */ (
			/** @type {any} */ $scope,
			/** @type {import('angular').ITimeoutService} */ $timeout,
		) => {
			$scope.deleteRule = () => {
				$scope.component.validate.pattern = undefined;
				$scope.component.description = undefined;
			};

			$scope.generate = () => {
				if (!$scope.data[$scope.component.key]?.name) {
					$scope.data[$scope.component.key] = {
						name: undefined,
						process: {
							value: 'K_NODE;HASH',
						},
					};
				}

				$scope.data[$scope.component.key].name = generator.generate({
					length:                   10,
					numbers:                  true,
					symbols:                  true,
					excludeSimilarCharacters: true,
				});
			};

			$scope.getProcessName = () => $scope.component.process.list.find(
				(
					/** @type {any} */ process,
				) => $scope.data && process.kid === $scope.data[$scope.component.key]?.process?.value,
			)?.name;

			$scope.isRequired = (
				/** @type {any} */ component,
				/** @type {string[]} */ componentsToRequire,
			) => component.validate?.card?.isRequired()
					|| (Array.isArray(componentsToRequire) && componentsToRequire.includes(component.key));

			$scope.updateRule = async (/** @type {any} */ value) => {
				if (value?.kid) {
					const repre = await APIV5.instance.objectRepreGet({
						items:    [value.kid],
						mode:     'all',
					}, {
						id: 'password.config.update-rule',
					});
					$timeout(() => {
						$scope.component.validate.pattern = repre?.result[value.kid]?.repre_all['K_NODE;REGEX']?.name ?? undefined;
						$scope.component.description = repre?.result[value.kid]?.repre_all['K_NODE;DESCRIPTION']?.name ?? undefined;
					});
				}
				else {
					$scope.component.validate.pattern = undefined;
				}
			};
		},
	});
};

export default angular.module('app').config(passwordConfig);
